import type { ApplicationStatus } from '../fixtures/domain.js';
import type { HiringStage } from '../fixtures/rules.js';
import { Icon } from '../components/Icon.js';
import { STAGE_META, nextMove } from './stageMeta.js';
import styles from './StageBar.module.css';

interface StageBarProps {
  status: ApplicationStatus;
  busy?: boolean;
  onStage: (target: HiringStage) => void;
  onReject: () => void;
  jobBounded?: boolean;
  /** Shown at any width, for a surface that is never wide. */
  compact?: boolean;
  /** No chat to end yet, so the ending is a plain Reject. */
  rejectOnly?: boolean;
}

/** The narrow column's stepper: the next stage and the ending, a half each. Past
 *  the last stage, and on a direct chat, the ending takes the whole band. */
export function StageBar({
  status,
  busy,
  onStage,
  onReject,
  jobBounded = true,
  compact,
  rejectOnly,
}: StageBarProps) {
  const { next, ending } = nextMove(status, jobBounded);

  return (
    <div className={compact ? `${styles.bar} ${styles.compact}` : styles.bar}>
      {next && (
        <button
          type="button"
          className={styles.half}
          disabled={busy}
          title={`Mark as ${STAGE_META[next].past}`}
          onClick={() => onStage(next)}
        >
          <Icon name={STAGE_META[next].icon} size={16} filled={false} />
          {STAGE_META[next].name}
        </button>
      )}
      <button type="button" className={styles.reject} disabled={busy} onClick={onReject}>
        <Icon name={ending.icon} size={16} />
        {rejectOnly ? 'Reject' : ending.label}
      </button>
    </div>
  );
}
